// extracted by mini-css-extract-plugin
export default {"chip":"MGChip_chip__xpdr9","label":"MGChip_label__JQRia","iconLeft":"MGChip_iconLeft__a0Ao6","iconRight":"MGChip_iconRight__9w8B3"};